import { MiniBentoStaticData } from './types';

export const MINI_BENTO_TYPES = {
  MAIN: 'miniBentoMain',
  VEGETARIAN: 'miniBentoVegetarian',
};

export const LABEL_BY_MINI_BENTO_TYPE = {
  [MINI_BENTO_TYPES.MAIN]: 'Non-Vegan Bentos',
  [MINI_BENTO_TYPES.VEGETARIAN]: 'Vegan-Friendly Bentos',
};

export const MINI_BENTO_STATIC_DATA: MiniBentoStaticData = {
  images: [
    '/images/static/catering/product/minibento/minibento1.jpg',
    '/images/static/catering/product/minibento/minibento2.jpg',
    '/images/static/catering/product/minibento/minibento3.jpg',
    '/images/static/catering/product/minibento/minibento4.jpg',
    '/images/static/catering/product/minibento/minibento5.jpg',
    '/images/static/catering/product/minibento/minibento6.jpg',
    '/images/static/catering/product/minibento/minibento7.jpg',
  ],
  prologue:
    'Our mini bentos are perfectly portioned for lighter appetites and shorter occasions. Individually packed for fuss-free distribution, each box delivers satisfying, macro-friendly flavours in a more compact serving. Ideal for meetings, workshops, tea breaks and events where a full-sized meal may be too much.',
  pricing: [],
  deliveryFee: {
    cbd: 50,
    nonCbd: 40,
    basePrice: 40,
  },
  basePriceLimit: 0,
  minBulkOrder: null,
  miniBentoMain: {
    title: 'Non-Vegan Bentos',
    description: 'Min. 10 Bentos per SKU',
    minOrder: 10,
    items: [
      {
        name: 'Mini Sambal Fish Set',
        description:
          'A spicy mini bento featuring fish with house-made sambal, Quinoa Lemak, Chinese cabbage, and a garnish of chopped spring onions.',
        price: 7.9,
        bulkPrice: 7.9,
      },
      {
        name: 'Mini Chicken Bulgogi Set',
        description:
          'Savoury chicken bulgogi served with Japanese short-grain rice and garlic stir-fried broccoli, finished with spring onions and roasted black sesame seeds.',
        price: 7.9,
        bulkPrice: 7.9,
      },
      {
        name: 'Mini Kopi Chicken Set',
        description:
          'A bold, energising meal featuring kopi-marinated chicken, fragrant sesame garlic penne and garlic stir-fried carrots, finished with roasted white sesame seeds and chopped spring onions.',
        price: 7.9,
        bulkPrice: 7.9,
      },
      {
        name: 'Mini Chicken Kolomee set',
        description:
          'Inspired by Sarawak kolo mee, this set features baked char siew chicken leg slices, springy kolo mee and poached xiao bai cai with YB Sambal, finished with chopped spring onions and crispy fried shallots.',
        price: 7.9,
        bulkPrice: 7.9,
      },
      {
        name: 'Mini Butter Chicken Set',
        description:
          'Tender chicken coated in a rich, creamy Indian-style butter sauce, served with Low GI basmati rice and broccoli poriyal, then finished with dried parsley flakes.',
        price: 7.9,
        bulkPrice: 7.9,
      },
      {
        name: 'Mini Korean-Style Spicy Chicken Set',
        description:
          'Spicy Korean-style chicken served with Japanese short-grain rice and Chinese cabbage, finished with chopped spring onions and roasted black sesame seeds.',
        price: 7.9,
        bulkPrice: 7.9,
      },
      {
        name: 'Mini Oaty Chicken Set',
        description:
          'Sweet and savoury cereal-style chicken made with oats and finished with cream cheese, served with baked sweet potatoes and stir-fried broccoli.',
        price: 7.9,
        bulkPrice: 7.9,
      },
      {
        name: 'Mini Salted Egg Chicken Set',
        description:
          'Steamed chicken coated in a rich, creamy house-made salted egg sauce made with cream cheese instead of butter, served with steamed red and brown rice and stir-fried carrots.',
        price: 7.9,
        bulkPrice: 7.9,
      },
      {
        name: 'Mini Kungpao Chicken Set',
        description:
          'Bold and savoury Kung Pao minced chicken served with Japanese short-grain rice and stir-fried bitter gourd with egg, finished with chopped spring onions and roasted black sesame seeds.',
        price: 7.9,
        bulkPrice: 7.9,
      },
      {
        name: 'Mini Beef Rendang Set',
        description:
          'Lean beef slices coated in a rich rendang sauce made with trimmed coconut milk and real spices, served with Quinoa Lemak and sambal long beans.',
        price: 8.9,
        bulkPrice: 8.9,
      },
      {
        name: 'Mini Chicken Panggang Set',
        description:
          'An Indonesian classic featuring skinless, boneless grilled chicken thigh marinated in-house with kecap manis, served with egg-fried barley rice and stir-fried carrots.',
        price: 7.9,
        bulkPrice: 7.9,
      },
    ],
  },
  miniBentoVegetarian: {
    title: 'Vegan-Friendly Bentos',
    description:
      'No minimum quantity, but must be ordered with other catering items.',
    minOrder: 0,
    items: [
      {
        name:
          'Mini Plant-Based Chicken Rendang Set (Vegetarian, Spicy)',
        description:
          'Plant-based chicken coated in an aromatic rendang sauce made with real rempah, trimmed coconut milk and toasted kerisik, served with Low GI basmati rice and rendang-coated long beans.',
        price: 7.9,
        bulkPrice: 7.9,
      },
      {
        name: 'Mini Stir-Fry Baked Tofu Set (Vegetarian, Non-Spicy)',
        description:
          'Baked tofu coated in a savoury sauce with carrots, served with whole wheat aglio olio spaghetti tossed with rainbow bell peppers and stir-fried broccoli.',
        price: 7.9,
        bulkPrice: 7.9,
      },
    ],
  },
};
